module.exports = __webpack_public_path__ + "4d4f6c5904522757597e34b8d74d16a7.png";